export class BrandStatisticsSortField{
    static readonly BrandName: number = 1;
    static readonly AssociatedToBrand: number = 2;
    static readonly CreatedUnidentifiedAd: number = 3;
    static readonly RequestCount: number = 4;
    static readonly MediaFile: number = 5;    
}


// WEBPACK FOOTER //
// ./src/app/brand-statistics/brand-statistics-sort.enum.ts